import { DirectiveOptions } from 'vue';

const hidden: DirectiveOptions = {
    bind(): void {
        // Do nothing
    },
};

export default hidden;
